export default {
  header: 'Hups, jotain odottamatonta tapahtui',
  text: 'Käynnistä sivu uudelleen tai napsauta alla olevaa ”Palaa valikkoon” -painiketta.',
  button: 'Palaa alkuun',
};
